import Icon from '@/components/common/Icon'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'
import type { FC } from 'react'
import { Trans } from 'react-i18next'

const OfflineWarningBanner: FC = () => {
  const isOnline = useOnlineStatus()

  return (
    <div
      className={[
        'flex min-h-0 flex-row items-center justify-start gap-1.5 overflow-hidden bg-red-700 px-4 transition-all duration-300',
        !isOnline ? 'max-h-[40px] py-2 opacity-100' : 'max-h-0 py-0 opacity-0',
      ].join(' ')}
      style={{ transformOrigin: 'top' }}
    >
      <Icon name="cloudOffOutlineRounded" />
      <p className="inline-flex items-center gap-2 text-sm">
        <Trans
          i18nKey="ls_auto_save_banner_message"
          components={{ b: <b /> }}
        />
      </p>
    </div>
  )
}

export default OfflineWarningBanner
